import { CanActivateFn, Router } from '@angular/router';
import { inject } from "@angular/core";
import { AccountService } from "../services/account.service";
import { catchError, filter, map, of } from "rxjs";

export const noAuthGuard: CanActivateFn = (route, state) => {
  const userService = inject(AccountService);
  const router = inject(Router);

  return userService.user$.pipe(
    map(user => {
      if (!user) {
        return true;
      } else {
        router.navigate(['calingo', 'pet', 'invoice'])
        return false;
      }
    }),
    catchError(() => {
      router.navigate(['/auth'])
      return of(false);
    })
  );
};
